import { CalendarType } from '@cbo/shared-library';
import { UseFormRegister, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import createFormTextField from '../../../../components/FormTextFields/FormTextFields';
import { getCalendarTypeOptions, getQuarterStyleOptions } from '../../utils/formOptions';

interface CalendarTypeFieldsProps {
  watchCalendarType: string;
  canEdit: boolean;
  register: UseFormRegister<FieldValues>;
}

export default function CalendarTypeFields({ watchCalendarType, canEdit, register }: CalendarTypeFieldsProps) {
  const { t } = useTranslation();
  const calendarTypeOptions = getCalendarTypeOptions();
  const quarterStyleOptions = getQuarterStyleOptions();

  return (
    <Grid item xs={12} container flexDirection='column' spacing={2}>
      {createFormTextField(
        {
          name: 'calendarType',
          variant: 'select',
          label: t('inventory.inventoryValuationSettings.calendarTypeLabel'),
          options: calendarTypeOptions,
          disabled: true,
          dataTestId: 'calendar-type-select',
          gridProps: { xs: 12, md: 4 },
        },
        { t, tKey: '' },
        register
      )}
      {watchCalendarType === CalendarType['12 months'] && (
        <>
          {createFormTextField(
            {
              name: 'quarterStyle',
              variant: 'select',
              label: t('inventory.inventoryValuationSettings.quarterStyleLabel'),
              options: quarterStyleOptions,
              disabled: true,
              dataTestId: 'quarter-style-select',
              gridProps: { xs: 12, md: 4 },
            },
            { t, tKey: '' },
            register
          )}
        </>
      )}
    </Grid>
  );
}
